import React, {createContext, memo, useContext, useMemo, useCallback} from 'react';
import './lots-list-item.css';

import LotHeaderInfo from "../../../lot-components/lot-header-info";
import AdminLotButtons from "../../../lot-components/admin-lot-buttons";
import ThirdBlock from "./third-block";
import FourthBlock from "./fourth-block";
import BidAndBuyNowBlock from "../../../lot-components/bids-and-buynow-block";
import AnswerForm from "./answer-form";

import LotListThumbnail from "../../../lot-components/lot-list-thumbnail/lot-list-thumbnail.jsx";
import useIsLotSelected from "./useIsLotSelected";
import {LotsContext} from "../../auction-lots-listing";

const lotContext = createContext();
export {lotContext}

const LotsListItem = memo(({lotData}) => {
    const {auction_id, color_background = 0} = lotData;

    const {promotion_color, show_img_lots_list} = useContext(LotsContext);
    const selected = useIsLotSelected(auction_id);

    // Мемоизируем стили для предотвращения пересоздания объектов
    const promotionStyle = useMemo(() => {
        return color_background === 1 && promotion_color ? 
            { backgroundColor: promotion_color } : 
            undefined;
    }, [color_background, promotion_color]);

    // Мемоизируем CSS классы
    const containerClasses = useMemo(() => 
        `container-fluid rounded shop-list-wrap shop-list-mrg2 shop-list-mrg-none mb-2 p-2${selected ? ' on-selected-lot' : ''}`,
        [selected]
    );

    const contentColumnClasses = useMemo(() => 
        show_img_lots_list ? 'col-lg-10 col-sm-9 col-12' : 'col-12',
        [show_img_lots_list]
    );

    // Мемоизируем контекст значения
    const lotContextValue = useMemo(() => ({ lotData }), [lotData]);

    return (
        <lotContext.Provider value={lotContextValue}>
            <div style={promotionStyle} className={containerClasses}>
                <div className="row align-items-center">
                    {show_img_lots_list && (
                        <div className="col-lg-2 col-sm-3 col-12 d-flex justify-content-center align-items-center">
                            <LotListThumbnail/>
                        </div>
                    )}

                    <div className={contentColumnClasses}>
                        <div className="row justify-content-center">
                            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 px-sm-2">
                                <LotHeaderInfo/>
                                <AdminLotButtons/>
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12 py-2 py-sm-0 px-sm-2 align-self-center text-muted">
                                <ThirdBlock/>
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-3 col-5 px-sm-2 align-self-center text-muted">
                                <FourthBlock/>
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-5 col-7 px-sm-2 align-self-center text-muted">
                                <BidAndBuyNowBlock/>
                            </div>
                        </div>
                    </div>
                    <AnswerForm/>
                </div>
            </div>
        </lotContext.Provider>
    )
});

export default LotsListItem;